import React from 'react';
import Icon from '../../../components/AppIcon';

const QuickStats = ({ stats }) => {
  const statItems = [
    {
      icon: 'Briefcase',
      label: 'Active Jobs',
      value: stats?.activeJobs,
      color: 'text-primary'
    },
    {
      icon: 'Building2',
      label: 'Companies',
      value: stats?.companies,
      color: 'text-accent'
    },
    {
      icon: 'Users',
      label: 'Job Seekers',
      value: stats?.jobSeekers,
      color: 'text-success'
    },
    {
      icon: 'TrendingUp',
      label: 'Placements',
      value: stats?.placements,
      color: 'text-warning'
    }
  ];

  return (
    <div className="flex flex-wrap items-center justify-center sm:justify-between gap-3 sm:gap-6 bg-card/70 backdrop-blur-sm rounded-xl py-2 px-4 border border-border/60 shadow-xs">
      {statItems?.map((item, index) => (
        <React.Fragment key={index}>
          <div className="flex items-center gap-2 py-0.5">
            <div className="w-6 h-6 rounded-md bg-muted flex items-center justify-center flex-shrink-0">
              <Icon name={item?.icon} size={14} className={item?.color} />
            </div>
            <div className="flex items-baseline gap-1.5">
              <span className="text-sm sm:text-base font-bold text-foreground tracking-tight">
                {item?.value?.toLocaleString()}
              </span>
              <span className="text-xs text-muted-foreground font-medium">
                {item?.label}
              </span>
            </div>
          </div>
          {index < statItems.length - 1 && (
            <div className="hidden sm:block w-px h-4 bg-border/60" />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default QuickStats;